/* ============================================================
   FLOWERTRAIL — The Roman Wheel
   A clean machined wheel of fortune: the engraved face spins
   behind a fixed gold jewel pointer and eases onto a numeral.
   Fully delegated events — the widget lives inside cart drawers
   that re-render on every cart change. Nothing here holds a
   reference that can go stale. Assets load once (theme.liquid).
   ============================================================ */
(function () {
  'use strict';
  if (window.__ftWheelInit) return;
  window.__ftWheelInit = true;

  var KEY = 'ftWheelResultV3';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEG = 45; /* eight bearings */

  function widgetOf(el) { return el.closest('[data-ft-wheel]'); }
  function q(w, sel) { return w ? w.querySelector(sel) : null; }

  function cfgOf(w) {
    try { return JSON.parse(q(w, '[data-ftw-config]').textContent); }
    catch (e) { return { code5: 'SPIN5', code10: 'SPIN10', code15: 'SPIN15', cooldownHours: 24 }; }
  }

  function segments(cfg) {
    return [
      { kind: 'code', code: cfg.code10, label: 'N — 10% off your order' },
      { kind: 'respin', label: 'NE — the compass grants another turn' },
      { kind: 'code', code: cfg.code5, label: 'E — 5% off your order' },
      { kind: 'none', label: 'SE — not today' },
      { kind: 'code', code: cfg.code5, label: 'S — 5% off your order' },
      { kind: 'code', code: cfg.code15, label: 'SW — 15% off. True north found.' },
      { kind: 'none', label: 'W — not today' },
      { kind: 'respin', label: 'NW — the compass grants another turn' }
    ];
  }

  function pickSegment(cfg) {
    var SEGS = segments(cfg);
    var buckets = [
      { test: function (s) { return s.code === cfg.code5; }, w: 34 },
      { test: function (s) { return s.code === cfg.code10; }, w: 16 },
      { test: function (s) { return s.code === cfg.code15; }, w: 4 },
      { test: function (s) { return s.kind === 'respin'; }, w: 16 },
      { test: function (s) { return s.kind === 'none'; }, w: 30 }
    ];
    var total = 0;
    buckets.forEach(function (b) { total += b.w; });
    var r = Math.random() * total;
    var chosen = buckets[buckets.length - 1];
    for (var i = 0; i < buckets.length; i++) {
      if (r < buckets[i].w) { chosen = buckets[i]; break; }
      r -= buckets[i].w;
    }
    var idxs = [];
    SEGS.forEach(function (s, i) { if (chosen.test(s)) idxs.push(i); });
    var idx = idxs[Math.floor(Math.random() * idxs.length)];
    return { idx: idx, seg: SEGS[idx] };
  }

  function readSaved(cfg) {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !d.t || (Date.now() - d.t) > (cfg.cooldownHours || 24) * 3600000) return null;
      return d;
    } catch (e) { return null; }
  }
  function saveResult(seg, idx) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), kind: seg.kind, code: seg.code || '', label: seg.label, idx: idx }));
    } catch (e) {}
  }

  function capLabel(w, text) {
    var l = q(w, '[data-ftw-cap-label]');
    if (l) l.textContent = text;
  }

  function lightGlow(w) {
    var g = q(w, '[data-ftw-glow]');
    if (g) g.classList.add('is-lit');
  }

  function setWheel(w, deg, animate) {
    var rotor = q(w, '[data-ftw-wheel]');
    if (!rotor) return;
    if (!animate) rotor.style.transition = 'none';
    rotor.style.transform = 'rotate(' + deg + 'deg)';
  }

  function showResult(w, seg, fromSave, idx) {
    var result = q(w, '[data-ftw-result]');
    var prize = q(w, '[data-ftw-prize]');
    var sub = q(w, '[data-ftw-result-sub]');
    var wrap = q(w, '[data-ftw-code-wrap]');
    var code = q(w, '[data-ftw-code]');
    var apply = q(w, '[data-ftw-apply]');
    var stage = q(w, '[data-ftw-stage]');
    var cap = q(w, '[data-ftw-spin]');
    if (!result || !prize) return;

    result.classList.add('is-shown');
    prize.textContent = seg.label;
    var subEl = q(w, '[data-ftw-sub]');
    if (subEl) subEl.textContent = 'One spin a day. Eight bearings — one true north.';
    if (cap) cap.disabled = true;
    capLabel(w, 'Spin');
    lightGlow(w);
    var fl = q(w, '[data-ftw-flash]');
    if (fl) {
      fl.style.transform = 'rotate(' + ((idx != null ? idx : 0) * SEG) + 'deg)';
      fl.classList.add('is-on');
    }
    if (fromSave && idx != null) setWheel(w, idx * SEG, false);

    if (seg.kind === 'code' && seg.code) {
      sub.textContent = fromSave ? 'Your prize from this round is still valid:' : 'The wheel has spoken. Your code:';
      wrap.style.display = '';
      code.textContent = seg.code;
      apply.style.display = '';
      apply.href = '/discount/' + encodeURIComponent(seg.code) + '?redirect=%2Fcart';
      if (!fromSave && stage && !reduceMotion) {
        stage.classList.remove('is-won');
        void stage.offsetWidth;
        stage.classList.add('is-won');
      }
    } else {
      sub.textContent = 'No prize this round — the wheel resets tomorrow.';
      wrap.style.display = 'none';
      apply.style.display = 'none';
    }
  }

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* toggle */
    var toggle = e.target.closest('[data-ftw-toggle]');
    if (toggle) {
      var w = widgetOf(toggle);
      if (!w) return;
      var open = w.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var saved = readSaved(cfgOf(w));
        if (saved && saved.kind !== 'respin') showResult(w, saved, true, saved.idx);
      }
      return;
    }

    /* spin */
    var cap = e.target.closest('[data-ftw-spin]');
    if (cap) {
      var w2 = widgetOf(cap);
      if (!w2 || w2.dataset.spinning === '1' || cap.disabled) return;
      var cfg = cfgOf(w2);
      var saved2 = readSaved(cfg);
      if (saved2 && saved2.kind !== 'respin') { showResult(w2, saved2, true, saved2.idx); return; }

      var rotor = q(w2, '[data-ftw-wheel]');
      if (!rotor) return;
      w2.dataset.spinning = '1';
      cap.disabled = true;
      capLabel(w2, '…');
      var stage = q(w2, '[data-ftw-stage]');
      if (stage) stage.classList.remove('is-landed');
      var fl0 = q(w2, '[data-ftw-flash]');
      if (fl0) fl0.classList.remove('is-on');

      var picked = pickSegment(cfg);
      var turns = (parseInt(w2.dataset.turns || '0', 10) + 5);
      w2.dataset.turns = String(turns);
      var jitter = 0; /* land dead on the engraving */
      var finalDeg = turns * 360 + picked.idx * SEG + jitter; /* needle rotates toward the pane */

      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        w2.dataset.spinning = '0';
        saveResult(picked.seg, picked.idx);
        if (!w2.isConnected) return; /* drawer re-rendered mid-spin: saved result shows on next open */
        if (picked.seg.kind === 'respin') {
          cap.disabled = false;
          capLabel(w2, 'Spin');
          var sub = q(w2, '[data-ftw-sub]');
          if (sub) sub.textContent = 'The wheel grants another turn — spin again.';
          var res = q(w2, '[data-ftw-result]');
          if (res) res.classList.remove('is-shown');
          var flr = q(w2, '[data-ftw-flash]');
          if (flr) flr.classList.remove('is-on');
        } else {
          if (stage && !reduceMotion) stage.classList.add('is-landed');
          showResult(w2, picked.seg, false, picked.idx);
        }
      };

      if (reduceMotion) {
        setWheel(w2, finalDeg, false);
        finish();
        return;
      }
      rotor.style.transition = 'transform 4.6s cubic-bezier(0.12, 0.84, 0.1, 1)';
      void rotor.getBoundingClientRect();
      rotor.style.transform = 'rotate(' + finalDeg + 'deg)';
      rotor.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 5300); /* safety if the node is replaced mid-spin */
      return;
    }

    /* copy */
    var copy = e.target.closest('[data-ftw-copy]');
    if (copy) {
      var w3 = widgetOf(copy);
      var codeEl = q(w3, '[data-ftw-code]');
      if (!codeEl) return;
      var text = codeEl.textContent.trim();
      var ok = function () {
        copy.textContent = 'Copied ✓';
        setTimeout(function () { copy.textContent = 'Copy'; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(ok).catch(function () { fallbackCopy(text, ok); });
      } else {
        fallbackCopy(text, ok);
      }
    }
  });

  function fallbackCopy(text, ok) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); ok(); } catch (e) {}
    document.body.removeChild(ta);
  }
})();
